import { Benchmark } from '../types/InternalAnalysis'
import { maxBenchmarks } from './analysisOverviewHelpers'

export type AnalysisQuery = { benchmarks?: Benchmark[]; version?: string | null }

// Legacy's `?comparedGames=a,b&marketIsos=us,jp&version=`, the lists paired by position.
export const toAnalysisQueryString = ({ benchmarks = [], version }: AnalysisQuery) => {
  const parts: string[] = []
  if (benchmarks.length) {
    parts.push(`comparedGames=${benchmarks.map(({ gameId }) => encodeURIComponent(gameId)).join(',')}`)
    parts.push(`marketIsos=${benchmarks.map(({ marketIso }) => encodeURIComponent(marketIso)).join(',')}`)
  }
  if (version) parts.push(`version=${encodeURIComponent(version)}`)
  return parts.length ? `?${parts.join('&')}` : ''
}

export const parseBenchmarks = (searchParams: URLSearchParams): Benchmark[] => {
  const gameIds = (searchParams.get('comparedGames') ?? '').split(',').filter(Boolean)
  const marketIsos = (searchParams.get('marketIsos') ?? '').split(',')
  return gameIds.flatMap((gameId, index) => (marketIsos[index] ? [{ gameId, marketIso: marketIsos[index] }] : [])).slice(0, maxBenchmarks)
}

export const getAnalysisOverviewPath = (analysisId: string, query: AnalysisQuery = {}) =>
  `/internal/analysis/${encodeURIComponent(analysisId)}/overview${toAnalysisQueryString(query)}`

// After a clone to another market the new analysis is compared with the game in that market, as in legacy.
export const getCreatedAnalysisPath = (analysisId: string, gameId: string, comparedMarketIso?: string) =>
  getAnalysisOverviewPath(analysisId, { benchmarks: comparedMarketIso ? [{ gameId, marketIso: comparedMarketIso }] : [] })

export const getAnalysisFeatureChoicesPath = (analysisId: string, categoryId: string, query: AnalysisQuery = {}) =>
  `/internal/analysis/${encodeURIComponent(analysisId)}/categories/${encodeURIComponent(categoryId)}${toAnalysisQueryString(query)}`
